import api from './axiosConfig';
import {
  BiometricAttendanceLogDto,
  BiometricDashboardDto,
  BiometricDeviceDto,
  BiometricSyncResultDto,
  EmployeeBiometricMapDto,
  SaveBiometricDeviceRequest,
  SaveEmployeeBiometricMapRequest,
} from '../types/biometricTypes';

export const biometricApi = {
  getDevices: async (searchTerm?: string, isActive?: boolean): Promise<BiometricDeviceDto[]> => {
    const response = await api.get<BiometricDeviceDto[]>('/biometric/devices', {
      params: { searchTerm, isActive },
    });
    return response.data;
  },

  createDevice: async (payload: SaveBiometricDeviceRequest): Promise<{ id: string }> => {
    const response = await api.post<{ id: string }>('/biometric/devices', payload);
    return response.data;
  },

  updateDevice: async (id: string, payload: SaveBiometricDeviceRequest): Promise<void> => {
    await api.put(`/biometric/devices/${id}`, { ...payload, id });
  },

  deleteDevice: async (id: string): Promise<void> => {
    await api.delete(`/biometric/devices/${id}`);
  },

  syncDevice: async (id: string): Promise<BiometricSyncResultDto> => {
    const response = await api.post<BiometricSyncResultDto>(`/biometric/devices/${id}/sync`);
    return response.data;
  },

  getMappings: async (biometricDeviceId?: string, searchTerm?: string): Promise<EmployeeBiometricMapDto[]> => {
    const response = await api.get<EmployeeBiometricMapDto[]>('/biometric/mappings', {
      params: { biometricDeviceId, searchTerm },
    });
    return response.data;
  },

  saveMapping: async (employeeId: string, payload: SaveEmployeeBiometricMapRequest): Promise<{ id: string }> => {
    const response = await api.put<{ id: string }>(`/biometric/mappings/${employeeId}`, payload);
    return response.data;
  },

  getLogs: async (params?: {
    biometricDeviceId?: string;
    startDate?: string;
    endDate?: string;
    searchTerm?: string;
  }): Promise<BiometricAttendanceLogDto[]> => {
    const response = await api.get<BiometricAttendanceLogDto[]>('/biometric/logs', { params });
    return response.data;
  },

  getDashboard: async (): Promise<BiometricDashboardDto> => {
    const response = await api.get<BiometricDashboardDto>('/biometric/dashboard');
    return response.data;
  },
};
